module.exports = ".hide-email-input {\n  visibility: hidden !important; }\n"